<template>
    <div>
        <rkm-form
            ref="FormFaturamento"
        >
            <rkm-row>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="faturamento.unidadeId"
                        :validations="validations.unidade"
                        value-field="id"
                        @change="getUnidades"
                    />

                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="faturamento.infraestruturaId"
                        :validations="validations.infraestrutura"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao"
                    :requestQueryStringParams="autocompletesResquestParams.queryString"
                    :searchFields="usuarios.autocomplete.usuario"
                    text-field="cidadaoNome"
                    :validations="validations.usuario"
                    :disabled="faturamento.unidadeId && faturamento.infraestruturaId ? false : true"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="faturamento.usuario"
                />
            </rkm-col>
            <rkm-col class="flex-grow-1">
                <rkm-form-select
                    label="CBO"
                    :options="ocupacao"
                    :validations="validations.ocupacao"
                    textField="codigoNome"
                    v-model="faturamento.ocupacaoId"
                    :disabled="!faturamento.usuario"
                    valueField="id"
                    show-default-option
                />
            </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.FormFaturamento.validate(add)"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="model.faturamentos"
            ref="Table"
            sort-by="unidadeNome"
            hide-filters
        >

            <template v-slot:cell(padrao)="{ item }">
                {{ item.padrao ? 'Sim' : 'Não' }}
            </template>

            <template v-slot:cell(ativo)="{ item }">
                {{ item.ativo ? 'Ativa' : 'Inativa' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    color="primary"
                    :disabled="!item.ativo || item.padrao"
                    :title="item.padrao ? 'Unidade padrão' : 'Definir como padrão'"
                    small
                    @click.stop="handlePadrao(item)"
                >
                    <rkm-icon icon="star" />
                </rkm-button>

                <rkm-button
                    v-if="item.ativo"
                    color="dark"
                    title="Inativar"
                    small
                    @click.stop="handleInativar(item)"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>

                <rkm-button
                    v-else
                    color="success"
                    title="Ativar"
                    small
                    @click.stop="handleAtivar(item)"
                >
                    <rkm-icon icon="check-circle" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(item)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { object, error, repository } from '@/mixins'

export default {
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('transportePaciente.parametrizacao')
        }
    },
    computed: {
        autocompletesResquestParams() {

            return {
                queryString: {
                    with_not_regularized: true,
                    with_lotacoes: true,
                    infraestrutura_id: this.faturamento.infraestruturaId,
                },
            }
        },
        fields() {

            const fields = [
                {
                    key: 'unidadeNome',
                    label: 'CNES - Unidade',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'usuarioNome',
                    label: 'CNS - Profissional',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'ocupacaoCodigoNome',
                    label: 'CBO - Especialidade',
                    class: 'col-max',
                    sortable: true
                },
                {
                    key: 'padrao',
                    label: 'Padrão',
                    class: 'col-min',
                    sortable: true
                },
                {
                    key: 'ativo',
                    label: 'Situação',
                    class: 'col-min',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]

            return fields
        },
        usuarios() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
                usuario: { required: true },
                ocupacao: { required: true },
            }
        },
        infraestruturas() {

            if (this.faturamento.unidadeId) {

                let infraestruturaPrincipal = this.form.unidades.find(u => u.id === this.faturamento.unidadeId).infraestruturas

                this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
    },
    data: () => ({
        ocupacao: [],
        faturamento: {
            unidadeId: null,
            infraestruturaId: null,
            usuario: null,
            ocupacaoId: null
        }
    }),
    methods: {
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const faturamento = this.clone(this.faturamento)

                    faturamento.unidadeNome = this.form.unidades
                        .find(s => s.id === faturamento.unidadeId).nomeFantasia

                    faturamento.ocupacaoCodigoNome = this.ocupacao
                        .find(s => s.id === faturamento.ocupacaoId).codigoNome

                    faturamento.infraestruturaNome = this.infraestruturas
                        .find(s => s.id === faturamento.infraestruturaId).nome

                    faturamento.usuarioNome = faturamento.usuario.cidadaoNome
                    faturamento.usuarioId = faturamento.usuario.id
                    faturamento.ativo = true
                    faturamento.padrao = false

                    this.model.faturamentos.push(faturamento)

                    this.ajustaPadrao()

                    this.resetForm()
                })
        },
        ajustaPadrao() {

            const ativos = this.model.faturamentos.filter(faturamento => faturamento.ativo)

            if (!ativos.length || ativos.some(faturamento => faturamento.padrao)) return

            this.$set(ativos[0], 'padrao', true)
        },
        handlePadrao(item) {

            const padraoAtual = this.model.faturamentos
                .find(faturamento => faturamento.padrao && faturamento !== item)

            const definir = async () => this.model.faturamentos
                .forEach(faturamento => this.$set(faturamento, 'padrao', faturamento === item))

            if (!padraoAtual) return definir()

            this.showConfirmation(`A unidade padrão atual é <strong>${ padraoAtual.unidadeNome }</strong>.
                Ao definir <strong>${ item.unidadeNome }</strong> como padrão, a anterior deixará de ser.
                A alteração vale somente para as produções geradas após o salvamento. Deseja continuar?`,
                definir)
        },
        handleInativar(item) {

            if (item.padrao) {

                this.showValidationNotification(`A unidade <strong>${ item.unidadeNome }</strong> é a unidade
                    padrão. Defina outra unidade ativa como padrão antes de inativá-la.`)

                return
            }

            const inativar = async () => {

                this.$set(item, 'ativo', false)
                this.$set(item, 'padrao', false)
            }

            this.showConfirmation(`Deseja realmente inativar a unidade <strong>${ item.unidadeNome }</strong>?
                Ela deixará de ser utilizada nas novas produções, sem alterar as produções já geradas.`,
                inativar)
        },
        handleAtivar(item) {

            const ativar = async () => {

                this.$set(item, 'ativo', true)

                this.ajustaPadrao()
            }

            this.showConfirmation(`Deseja realmente ativar a unidade <strong>${ item.unidadeNome }</strong>?`,
                ativar)
        },
        async validate() {

            const hasSetor = this.model.faturamentos
                .find(cc => cc.unidadeId === this.faturamento.unidadeId
                    && cc.infraestruturaId === this.faturamento.infraestruturaId
                    && cc.usuarioId === this.faturamento.usuario.id)

            if (hasSetor) {

                const unidadeSolicitante = this.form.unidades
                    .find(s => s.id === this.faturamento.unidadeId).nomeFantasia

                const infraestruturaNome = this.infraestruturas
                    .find(s => s.id === this.faturamento.infraestruturaId).nome

                this.showValidationNotification(`A unidade <strong>${ unidadeSolicitante }</strong>,
                    local de atendimento <strong>${ infraestruturaNome }</strong> e o(a) profissional
                    <strong>${ this.faturamento.usuario.cidadaoNome }</strong> já estão cadastrados.`)

                return false
            }

            return true
        },
        resetForm() {

            this.faturamento.unidadeId = null
            this.faturamento.infraestruturaId = null
            this.faturamento.usuario = null
            this.faturamento.ocupacaoId = null

            this.$nextTick(() => this.$refs.FormFaturamento.resetValidator())
        },
        loadLotacoes(lotacao) {

            const ocupacoesFiltradas = lotacao.filter(
                u => u.unidadeId === this.faturamento.unidadeId
                && u.infraestruturaId === this.faturamento.infraestruturaId
            );

            this.ocupacao = ocupacoesFiltradas.map(ocupacao => ocupacao.ocupacao);

            if (this.ocupacao.length === 1) {
                this.faturamento.ocupacaoId = this.ocupacao[0].id;
            }
        },
        getPrincipal(infraestruturaPrincipal) {

            const unidadePrincipal = infraestruturaPrincipal.find(u => u.principal);

            this.faturamento.infraestruturaId = unidadePrincipal ? unidadePrincipal.id : infraestruturaPrincipal[0].id;
        },
        handleDestroy(item) {

            const verificaFaturamento = this.model.bpaFaturamento.find(bpa => bpa.unidadeId == item.unidadeId)

            if (verificaFaturamento) {

                this.showValidationNotification(`A unidade <strong>${ item.unidadeNome }</strong>
                    já foi faturada, não é possível excluir. Inative a unidade para impedir o uso
                    em novas produções.`)

                return
            }

            if (item.padrao && this.model.faturamentos.some(faturamento => faturamento !== item && faturamento.ativo)) {

                this.showValidationNotification(`A unidade <strong>${ item.unidadeNome }</strong> é a unidade
                    padrão. Defina outra unidade ativa como padrão antes de excluí-la.`)

                return
            }

            const destroy = async () => {

                this.model.faturamentos.splice(this.model.faturamentos.indexOf(item), 1)

                this.ajustaPadrao()
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a unidade <strong>${ item.unidadeNome }</strong>,
                local de atendimento <strong>${ item.infraestruturaNome }</strong>
                e o(a) profissional <strong>${ item.usuarioNome }</strong>?`,
                destroy)
        },
        getUnidades(){

             const verificaUnidade = this.model.faturamentos
                .find(cc => cc.unidadeId === this.faturamento.unidadeId)

                if(verificaUnidade){

                    const unidadeSolicitante = this.form.unidades
                        .find(s => s.id === this.faturamento.unidadeId).nomeFantasia

                    this.showValidationNotification(verificaUnidade.ativo
                        ? `A unidade <strong>${ unidadeSolicitante }</strong>,
                            já está parametrizada para faturamento.`
                        : `A unidade <strong>${ unidadeSolicitante }</strong> está parametrizada e inativa.
                            Ative-a na lista para voltar a utilizá-la.`)

                    this.faturamento.unidadeId = null

                    return false
                }

            return true
        }
    },
    mixins: [object, error, repository ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    watch: {
        'faturamento.unidadeId' () {

            this.faturamento.infraestruturaId = null
        },
        'faturamento.infraestruturaId' () {

            this.faturamento.usuario = null
        },
        'faturamento.usuario' (usuario) {

            this.ocupacao = []
            this.faturamento.ocupacaoId = null

            if (usuario) {

                this.repositories.parametrizacao.lotacoes({
                    'usuario_id': usuario.id,
                    'infraestrutura_id': this.faturamento.infraestruturaId
                })
                    .then(response => {

                        this.loadLotacoes(response.data.lotacoes)
                    })
                    .catch(this.handleError)
                    .finally()
            }
        },
    }
}
</script>